var map = {
	"./strings.en-US.resjson": [
		91,
		9417
	],
	"./strings.ja-JP.resjson": [
		19299,
		1969
	],
	"./strings.ja.resjson": [
		1860,
		5188
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98514;
module.exports = webpackAsyncContext;